import React from 'react';
import { Card, CardContent } from './ui/card';
import { registrationProcess } from '../data/mock';
import { CheckCircle } from 'lucide-react';

export const ProcessSection = () => {
  return (
    <section id="process" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-4">
            Our Trademark Registration Process
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            A streamlined, transparent 3-step process to secure your trademark and protect your brand identity.
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            {registrationProcess.map((step) => (
              <Card
                key={step.step}
                className="border-2 border-emerald-200 hover:shadow-2xl transition-all duration-300 hover:border-amber-500 hover:-translate-y-2"
              >
                <CardContent className="p-8">
                  <div className="flex flex-col items-center text-center mb-6">
                    <div className="bg-gradient-to-br from-emerald-700 to-emerald-600 text-white w-16 h-16 rounded-full flex items-center justify-center font-bold text-2xl mb-4 shadow-lg">
                      {step.step}
                    </div>
                    <div className="bg-amber-100 w-12 h-12 rounded-full flex items-center justify-center -mt-2 mb-6">
                      <CheckCircle className="h-6 w-6 text-emerald-700" />
                    </div>
                  </div>
                  
                  <h3 className="text-xl font-bold text-emerald-900 mb-4 text-center">
                    {step.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed text-center">
                    {step.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
